import React from "react";

import QuoteInformationPanel from "EmployerApplication/Components/QuoteInformationPanel";
import RenewalProcessOverview from "EmployerApplication/Components/RenewalProcessOverview";

import FactsAndQuestionsCard from "Common/FactsAndQuestionsCard/FactsAndQuestionsCard";
import { Grid, Row, Col } from "Common/Grid";
import { Div } from "Common/HTML";
import { SizeSwitch } from "Common/Responsive";

import EmployerApplicationMenu from "./EmployerApplicationMenu";

const ApplicationLayout = ({ withQuotePanel, isRenewal, children }) => (
  <Div className="min-h-dvh" mb={6}>
    <Grid>
      <Row>
        <Col md={12} mb={3} mt={6}>
          {isRenewal ? <RenewalProcessOverview /> : <EmployerApplicationMenu sticky={false} />}
        </Col>
      </Row>
      <Row>
        <Col md={withQuotePanel ? 9 : 12}>
          {children}
          <FactsAndQuestionsCard />
        </Col>
        {withQuotePanel && (
          <SizeSwitch
            md={
              <Col md={3} pl={0}>
                <QuoteInformationPanel />
              </Col>
            }
          />
        )}
      </Row>
    </Grid>
  </Div>
);

export default ApplicationLayout;
